export default {
    signup: {
        title: 'Sign Up - MedMatch Network',
        page_description: 'Sign up for MedMatch Network to streamline referrals and enhance patient care. Join us today',
        page_keywords: 'MedMatch Network, sign up, healthcare referrals, patient care',
        page_author: 'MedMatch Network',
        page_robots: 'index, follow',
        dont_have_npi: 'Don’t Have NPI?',
        start_new_registration: 'Start New Registration',
        npi_number_not_found: 'NPI number not found',
        npi_number_must_be_10_digits: 'NPI number must be 10 digits',
        demo: {
            register: {
                heading: 'Demo account',
                title: 'View Demo - MedMatch Network',
                description: 'Seamless patient referral management and services.',
                page_description:
                    'Join Ehda, our AI Assistant, for a hands-on tour of MedMatch Network. Discover how our platform enhances healthcare referrals.',
                page_keywords: 'MedMatch Network, demo, AI Assistant, healthcare referrals',
                page_author: 'MedMatch Network',
                page_robots: 'index, follow',
            },
            go_back: 'Go back',
        },
        steps: {
            register: {
                heading: 'Sign up with MedMatch Network',
                heading_two: 'Start your FREE PREMIUM TRIAL today! 🎉',
                heading_network: 'Stay on NETWORK plan FREE FOREVER...',
                heading_outsider: 'Please create a secure account to retrieve referral information',
                description: {
                    or: 'or',
                    login: 'Login to your account',
                    invite: 'Complete your information to join',
                },
                confirm_practice_modal: {
                    practices_number: 'There is 1 practice with name | There are {n} practices with name',
                    join_text: 'Would you like to join this',
                    join_text_physician: 'practice or register a new one?',
                    join_text_non_physician: 'practice?',
                    created_by: 'created by {name}',
                    register_new: 'Register a new one',
                    join_existing: 'Join this practice',
                },
                byword: 'Make, receive, and track referrals with intelligent matching and intuitive tracking.',
            },
            practice: {
                heading: 'Your {type}',
                description1: 'Tell us more about your organization',
                description2: 'Tell us about your practice',
                byword: {
                    physician: 'Put your practice on the map for new referrals!',
                    ancillary: 'Put your organization on the map for new business!',
                },
                practice_missing: {
                    heading: 'You will be notified when your practice account is created.',
                    invite_sent: 'Invite sent!',
                    practice_not_registred: 'Your practice has not been registered yet!',
                    back_to_login: 'Back to Login',
                },
            },
            practice_membership: {
                membership_pending_heading: 'Membership under review.',
                membership_denied_heading: 'Membership denied.',
                membership_approved_heading: 'We need to validate your email address.',
                membership_revoked_heading: 'Membership revoked.',
                membership_just_confirmed_heading: 'Thank you for registering!',
                membership_pending_content:
                    'Your account will be active once your designated practice administrator confirms your membership.',
                membership_denied_content: '{practiceName} designated administrator has denied your membership.',
                membership_revoked_content: 'Your {practiceName} memberhsip has been revoked.',
                membership_approved_content: 'In order to activate your account we need to validate your email address.',
                membership_pending_footer:
                    'Once your membership is confirmed, we will send you an email at <a>{email}</a> with a link to confirm your account.',
                membership_denied_footer: 'For more information contact your practice designated administrator',
                membership_approved_footer: "<b>Can't find the email?</b>",
                resend_email: ' member confirmation email.',
                email_sent: 'Email successfully sent! Check your inbox.',
                please_use_confirmation_link:
                    'Please use the link in the email we sent you at <a>{email}</a> with the confirmation of your {practiceName} membership.',
                buttons: {
                    resend: 'Resend',
                },
            },
            profile: {
                heading: 'Your credentials',
                admin_heading: '{name} creadentials',
                admin_description: 'Enter provider professional profile',
                byword: 'Establish your credentials',
                mobile: {
                    email_link: "We've sent you email to <a>{email}</a> with a link to complete your registration.",
                    send_link: 'You can also send the link to your practice administrator to complete your professional profile.',
                    invite_content: 'You will be notified when your profile will be completed.',
                },
            },
            register_physicians: {
                heading: 'Register your providers',
                heading_physician_completed: 'Provider {name} successfully registered!',
                description: 'Enter your providers information.',
                description_physician_completed_no_password:
                    'An email to {name} has been sent at <a>{email}</a> to set password and activate the account.',
                description_physician_completed: '{name} will be notified by email.',
                invite_description: 'Set up your provider team.',
                register_description: 'Enter provider information.',
                register_subheader: 'Register new provider',
                invite_subheader: 'Enter provider email addresses',
                or_invite: 'Or invite them to do it',
                or_finalize: 'Or finalize practice registration',
                already_registred: 'ALREADY REGISTERED',
                incomplete_profile: 'WITH INCOMPLETE PROFILE',
                set_availability: 'Set Availability',
                buttons: {
                    register_physicians: 'Register providers',
                    register_another: 'Register another provider',
                    finalize_registration: 'Finalize registration',
                    invite_physicians: 'Invite providers',
                    back: 'Back',
                },
                modals: {
                    register_physicians_modal: {
                        heading: '{practiceName} providers',
                        close: 'Close',
                        complete_profile: 'Set availability',
                    },
                    invite_email_check: {
                        button_1_label: 'Invite other providers',
                        button_2_label: 'Finalize registration',
                    },
                    complete_profile: {
                        profile_complete: 'Availability complete',
                        profile_incomplete: 'Availability incomplete',
                    },
                    import_contacts_modal: {
                        send_button_label: 'Add',
                    },
                },
                form: {
                    heading: 'Enter provider email addresses',
                    skip_link_label: 'Skip for now',
                    field_label: 'Provider',
                    field_placeholder: 'membername@email.com',
                    button_label: 'Send invite',
                },
                constants: {
                    practice_type: 'physician',
                },
            },
            schedule: {
                heading: 'You’re almost done!',
                description: 'Set your availability and start getting referrals',
                admin_description: 'Set {name} availability to complete the profile.',
                review_label: 'Please review your availability',
                start_date_label: 'Please set start date',
                byword: 'Maximize your patient referrals. Set your schedule for booking new appointments and let MedMatch Network take care of the rest.',
            },
            connecting: {
                heading: 'Start building your network',
                description: 'Invite your colleagues to join MedMatch',
                constants: {
                    practice_type: 'provider',
                },
                form: {
                    skip_link_label: 'Skip for now',
                    field_label: 'Provider #',
                    field_placeholder: 'Enter email address',
                    button_label: 'Send invite',
                },
                modal_popup: {
                    button_1_label: 'Invite others',
                    button_2_label: 'Complete sign up',
                },
            },
            congratulations: {
                heading: 'Congratulations!',
                validate_heading: 'Please validate your email address.',
                please_use_confirmation_link: 'Please use the link in the email we sent you at <a>{email}</a>',
                description: 'Your MedMatch Network account has been successfully created.',
                byword: 'All done!<br>Welcome to MedMatch!',
                content: {
                    intro: 'We have sent you an email to <a>{email}</a> with a link to validate your account.',
                    cant_find: 'Cant find the email?',
                    footer: 'Please check your spam folder',
                    button: {
                        send: 'Resend',
                        sending: 'sending…',
                        sent: 'Sent! Check your inbox',
                        proceed_to_dashboard: 'Proceed to dashboard',
                    },
                },
                verified: {
                    to_open: 'Click below to open the MedMatch Network dashboard and begin making and receiving referrals!',
                    open_dashboard: 'Open dashboard',
                },
                mobile: {
                    thank_you: 'Thank you for joining',
                    email_link: "We've sent you email to <a>{email}</a> with a link to activate your account.",
                    warning_non_master_users: 'For a better experience,<br>please continue from a <b>desktop computer</b>.',
                    login_header: 'Thank you for using Medmatch',
                },
            },
            mobile_warning: {
                heading: 'Thank you for registering',
                content: {
                    intro: 'For a better experience,<br>please continue setup on<br>a <b>desktop computer</b>.',
                    email_link:
                        "We've sent you an email to <a>{email}</a> with a link to confirm your account and complete practice registration.",
                    send_link: 'You can also send a link to your practice administrator to complete the setup.',
                    send_link_button: 'Send Link',
                    sent_link_button: 'Sent!',
                    button: {
                        label: 'Practice Administrator email',
                        send: 'resend confirmation email',
                        sending: 'sending…',
                        sent: 'sent! Check your inbox',
                    },
                },
            },
            physician_password: {
                heading: 'Welcome {physicianFullName}!',
                description: 'Set your password and join {practiceName}',
                button: 'Next',
                byword: 'Make, receive and track referrals',
            },
        },
    },
    login: {
        title: 'Login - MedMatch Network',
        heading: 'Sign in to MedMatch Network',
        heading_mobile: 'Sign in',
        description: 'Enter your details below.',
        dont_have_account: 'Don’t have an account?',
        create_one_free: 'Create one for FREE',
        get_started: 'Get started',
        verified: {
            success: 'Your email has been successfully verified. You can now login to your MedMatch Network account.',
            error: 'Email verification link is invalid or has expired!',
            email_sent: 'You should have received a password reset email. Please check your inbox.',
        },
        page_description: 'Log in to MedMatch Network to streamline referrals and enhance patient care. Access your account now.',
        page_keywords: 'MedMatch Network, login, healthcare referrals, patient care',
        page_author: 'MedMatch Network',
        page_robots: 'index, follow',
    },
    forgot_password: {
        title: 'Reset your password',
        heading: {
            initial: 'Reset your password',
            done: 'Done! Check your email',
        },
        description: 'We’ll email you instructions to reset your password.',
        back_to_login: 'Back to login',
        sent_instructions: 'We’ve sent an email to <b>{email}</b> with password reset instructions.',
        check_spam: 'If the email doesn’t show up soon, check your spam folder.',
        resent_email: 'Resend email',
        resending: 'Sending…',
        resent_sent: 'Sent! Check your inbox',
        resent_failed: 'Unable to resend email. Please try again later.',
        resent_limit: 'Too many attempts. Please wait a minute and try again.',
    },
    reset_password: {
        title: 'Reset your password',
        heading: {
            initial: 'Reset your password',
            set_password: 'Set your password',
            done: 'New password confirmed!',
            error: 'Link invalid',
        },
        token_expired: 'The request has expired. Click',
        token_expired_here: 'here',
        token_expired_resend: 'to resend the email.',
        description: {
            initial: 'Please enter your new password.',
            error: 'The link has expired or does not exist.',
        },
        back_to_login: 'Return to login',
        send_again: 'Send link again',
    },
    select_physician: {
        title: 'Activate provider',
        heading: 'Which provider would you like to activate first in MedMatch?',
        invite_other_physicians_link: 'Invite other providers',
    },
    invite_member: {
        title: 'Invite member',
        heading1: 'Hi {firstName} {lastName}, welcome to MedMatch',
        content1: "It's now time to invite members of {practiceName} to join MedMatch Network and get referrals",
        heading2: 'Invites sent!',
        content2: 'As soon as the invited providers will join MedMatch Network you will be able to activate their profile.',
        buttons: {
            log_out: 'Log out',
            invite_others: 'Invite others',
            show_my_physicians: 'Show my providers',
            collect_contacts: 'Add',
        },
        constants: {
            practice_type: 'physician',
        },
    },
    invites: {
        user_already_invited: 'Your practice administrator has been already invited to join MedMatch. Would you like to ',
        send_reminder: 'send a reminder?',
        buttons: {
            send_request: 'Send request',
            register_practice: 'Register practice',
            info: 'You need at least one provider to go live',
        },
        fromuser_email: 'Current provider user has outstanding invitations, therefore practice registration is mandatory.',
    },
    verify_email: {
        heading: 'Enter Your Email',
        content: 'Please provide your email address to receive a verification code',
        activating: 'Activating your account...',
        form: {
            email: {
                label: 'Email',
                placeholder: 'john.smith@myemail.com',
            },
            cancel: 'Cancel',
            send_code: 'Send code',
        },
        errors: {
            email_required: 'Email is required',
            email_invalid: 'Please enter a valid email address',
            failed_to_send_code: 'Failed to send verification code. Please try again.',
        },
    },
    verify_code: {
        heading: 'Enter Verification Code',
        content: "We've sent a 6-digit code to {email}",
        form: {
            cancel: 'Cancel',
            verify_code: 'Verify code',
        },
        errors: {
            code_required: 'Code is required',
            code_invalid: 'Please enter a valid code',
            failed_to_verify_code: 'Failed to verify code. Please try again.',
        },
    },
    verify_token: {
        heading: 'Welcome to MedMatch Network',
        heading_token_only: 'Access Referral Details',
        heading_confirm_npi: 'Confirm Your NPI',
        heading_email: 'Enter Your Email',
        heading_verifying: 'Verifying Invitation',
        content:
            'A member of our team just spoke with you about a new patient referral. Enter your NPI and the access token you were given on the call to continue. NPI is optional if you received this referral by email.',
        content_token_only: 'Enter the token from your invitation email to access referral details',
        content_confirm_npi: 'This referral was sent to your NPI. Enter your NPI number to confirm access.',
        content_email: 'Please provide your email address to receive a verification code',
        content_verifying: 'Checking your invitation…',
        secure_note: 'Secure connection · used only for this referral',
        legal: "By continuing, you'll be taken to the secure MedMatch Network application to review and accept this referral. © 2026 MedMatch Network. All rights reserved.",
        form: {
            npi_number: {
                label: 'NPI Number',
                placeholder: '10-digit NPI',
                help: 'Optional if received by email. The 10-digit National Provider Identifier for your practice.',
            },
            token: {
                label: 'Access Token',
                placeholder: 'E.G. AF1BC9',
                help: 'The 6-character code provided during your call or in your email.',
            },
            verify: 'Continue to Referral',
        },
        errors: {
            npi_required: 'NPI is required for this invitation',
            npi_must_be_10_digits: 'NPI must be 10 digits',
            npi_mismatch: 'NPI number does not match this invitation',
            token_required: 'Token required',
            token_expired: 'Your token has expired',
            token_invalid: 'Invalid token',
            token_invalid_common: 'Invalid token or NPI number. Please try again.',
            token_invalid_token_only: 'Invalid token. Please try again.',
        },
        referral_info: {
            heading: 'Secure Referral Request',
            share_id: 'Share ID',
            share_id_prefix: 'REF',
            sender: 'Sender',
            timeframe: 'Timeframe',
            created_at: 'Created At',
            service_requested: 'Service Requested',
            tests: 'Tests',
            expires_at: 'Expires At',
            clinical_documents: 'Clinical Documents',
            view: 'View',
            download: 'Download',
            response_actions: 'Response Actions',
            accept_referral: 'Accept Referral',
            request_more_info: 'Request More Info',
            decline: 'Decline',
            participation_status: 'Participation Status',
            external: 'External',
            participation_text: 'You are currently participating in secure clinical referrals on a per-session basis.',
        },
        response_actions: {
            accept_referral: 'Accept Referral',
            request_more_info: 'Request More Info',
            decline: 'Decline',
        },
        participation_status: {
            external: 'External',
        },
    },
    head: {
        title: 'Close the Loop on Medical Referral Management',
        description: 'Automate patient referrals in the cloud safely and securely.',
        image: 'https://d28mrr93a9s7g3.cloudfront.net/images/open-graph/MedMatch-Homepage-OG-Image.jpg',
        robots: 'noindex, nofollow',
        author: 'MedMatch Network',
        keywords: 'MedMatch Network, sign up, healthcare referrals, patient care',
    },
    landing_page: {
        title: 'Enhanced Medical Referral Management | MedMatch',
        description: '',
        image: '',
    },
    find_provider: {
        title: 'Find Provider - MedMatch Network',
        page_description:
            "Find the right healthcare provider using MedMatch Network's search tool. Access our extensive network of specialists and primary care providers.",
        page_keywords: 'MedMatch Network, find provider, healthcare provider, specialists, primary care',
        page_author: 'MedMatch Network',
        page_robots: 'index, follow',
    },
}
